import PropTypes from 'prop-types';
import React from 'react';

import UserProfileEditBaseForm from '../../organisms/userProfile/UserProfileEditBaseForm';

class UserProfileEditBase extends React.Component {
  static get propTypes() {
    return {
      state: PropTypes.shape({
        userProfileBaseEdit: PropTypes.shape({
          isError: PropTypes.bool,
          isEdit: PropTypes.bool,
          errorMessage: PropTypes.string,
          messages: PropTypes.object,
        }),
      }),
      initState: PropTypes.func,
      fetchEditBaseDetail: PropTypes.func,
      postBaseEdit: PropTypes.func,
      history: PropTypes.shape({
        push: PropTypes.func,
      }),
    };
  }

  constructor(props) {
    super(props);

    this.onEdit = this.onEdit.bind(this);
  }

  componentDidMount() {
    this.props.fetchEditBaseDetail();
  }

  onEdit(values) {
    console.debug('onEdit values: ', values);
    this.props.postBaseEdit(values);
  }

  onSubmit() {}

  transitionToComplete() {
    this.props.initState();
    this.props.history.push(`/user/profile`);
  }

  render() {
    const updateSuccess = () => {
      if (this.props.state.userProfileBaseEdit.isEdit) {
        this.transitionToComplete();
      }
    };

    return (
      <>
        {updateSuccess()}
        <UserProfileEditBaseForm
          onSubmit={this.onSubmit}
          onEdit={this.onEdit}
          errorMessage={this.props.state.userProfileBaseEdit.errorMessage}
          messages={this.props.state.userProfileBaseEdit.messages}
        />
      </>
    );
  }
}

export default UserProfileEditBase;
